module.exports = __webpack_public_path__ + "img/blue.e460d768.png";